export const SDK_VERSION = '6.8.0';
